import { ModalTemplateWrapper } from '#app/components/Modals/V2/GlobalModalSystem/ModalTemplateWrapper/ModalTemplateWrapper.js';
import { type CommonTemplateProps } from '#app/components/Modals/V2/GlobalModalSystem/types.js';
import { Text } from '#app/components/Primitives/Text.js';
import { useIsMobile } from '#app/hooks/useIsMobile.js';
import { type ReactNode } from 'react';

type SearchFiltersModalProps = CommonTemplateProps & {
  readonly appliedFilterCount: number;
  readonly children: ReactNode;
  readonly modalLabel?: string;
  readonly onClearFilters: VoidFunction;
  readonly resultCount: number;
};

export const SearchFiltersModal = ({
  appliedFilterCount,
  children,
  closeModal,
  isOpen,
  modalLabel = 'Discover Freelancers Filter Modal',
  onClearFilters,
  resultCount,
}: SearchFiltersModalProps): JSX.Element => {
  const resultLabel =
    resultCount > 0 && appliedFilterCount > 0
      ? `View ${resultCount} results`
      : 'View results';

  const isMobile = useIsMobile();

  return (
    <ModalTemplateWrapper
      ariaLabel={modalLabel}
      ctaOptions={{
        primaryCTA: {
          ariaLabel: 'View results',
          handleOnClick: () => {
            closeModal();
          },
          label: isMobile ? 'View results' : resultLabel,
        },
        secondaryCTA: {
          ariaLabel: 'Clear filters',
          handleOnClick: () => {
            onClearFilters();
            closeModal();
          },
          label: 'Clear filters',
        },
      }}
      desktopModalSize="xlarge"
      headerText={
        <Text textStyle="fifthLevelHeadline">
          All filters ({appliedFilterCount})
        </Text>
      }
      isFullscreenOnMobile
      isOpen={isOpen}
      onClose={closeModal}
    >
      {children}
    </ModalTemplateWrapper>
  );
};
